import { useSessionStorage } from '@vueuse/core'

export const useTelegramMiniApp = () => {
  const isMiniApp = useSessionStorage<boolean | null>(
    'dphub/telegram/is-mini-app',
    null,
    {
      listenToStorageChanges: false,
      serializer: {
        // prettier-ignore
        read: v => v === 'true'
          ? true
          : v === 'false' ? false : null,
        write: v => String(v)
      }
    }
  )

  const initDataStored = useSessionStorage('dphub/telegram/init-data', '', {
    listenToStorageChanges: false
  })

  const telegram = useState<typeof Telegram | null>(() => shallowRef(null))

  const defineAppAs = () => {
    if (isMiniApp.value === null) {
      isMiniApp.value = window.location.hash.includes('telegramMiniApp')
    }

    return isMiniApp.value
  }

  const loadTelegramScript = () =>
    new Promise<void>((resolve, reject) => {
      const script = document.createElement('script')

      script.src = 'https://telegram.org/js/telegram-web-app.js?56'

      script.onload = () => {
        if (typeof Telegram === 'undefined') {
          reject(new Error('Telegram is out of reach'))
        } else {
          telegram.value = Telegram

          if (!initDataStored.value) {
            initDataStored.value = telegram.value.WebApp.initData
          }

          resolve()
        }
      }

      script.onerror = () => {
        reject(new Error('An error occurred while loading the script'))
      }

      document.head.appendChild(script)
    })

  const initMiniAppSafely = () => {
    const asMiniApp = defineAppAs()

    if (asMiniApp) {
      return loadTelegramScript()
    }
  }

  return {
    isMiniApp: readonly(isMiniApp),
    initDataStored: readonly(initDataStored),
    telegram: readonly(telegram),
    initMiniAppSafely
  }
}
